var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockerlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 10.4H22.1C22.4448 10.4 22.7754 10.537 23.0192 10.7808C23.263 11.0246 23.4 11.3552 23.4 11.7V24.7C23.4 25.0448 23.263 25.3754 23.0192 25.6192C22.7754 25.863 22.4448 26 22.1 26H1.3C0.955218 26 0.624558 25.863 0.380761 25.6192C0.136964 25.3754 0 25.0448 0 24.7V11.7C0 11.3552 0.136964 11.0246 0.380761 10.7808C0.624558 10.537 0.955218 10.4 1.3 10.4H2.6V9.1C2.6 7.90497 2.83538 6.72164 3.2927 5.61758C3.75001 4.51352 4.42031 3.51034 5.26533 2.66533C6.11034 1.82032 7.11352 1.15001 8.21758 0.692696C9.32164 0.235378 10.505 0 11.7 0C12.895 0 14.0784 0.235378 15.1824 0.692696C16.2865 1.15001 17.2897 1.82032 18.1347 2.66533C18.9797 3.51034 19.65 4.51352 20.1073 5.61758C20.5646 6.72164 20.8 7.90497 20.8 9.1V10.4ZM2.6 13V23.4H20.8V13H2.6ZM10.4 15.6H13V20.8H10.4V15.6ZM18.2 10.4V9.1C18.2 7.37609 17.5152 5.72279 16.2962 4.50381C15.0772 3.28482 13.4239 2.6 11.7 2.6C9.97609 2.6 8.32279 3.28482 7.10381 4.50381C5.88482 5.72279 5.2 7.37609 5.2 9.1V10.4H18.2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockerlogo);
export default __webpack_public_path__ + "static/media/lockerlogo.c9bdfe760d312ce673d9ea49c5c128dc.svg";
export { ForwardRef as ReactComponent };